export default "__VITE_ASSET__ba1c4e14__"